import React, { useState } from "react";
import { BsFillPlusCircleFill } from "react-icons/bs";
import ReportUploadModal from "./TeanatUploadModel";
import TenantModal from "./TenantModal";
import type { CreateTenantData } from "../../../shared/types/tenant";
import { useAppSelector } from "../../../redux/store";
import { createTenant } from "../../../shared/services/apis";
// import { useBrand } from "../../../context/brandContext";

const TenantUpload: React.FC = () => {
  const auth = useAppSelector((state) => state.auth);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isTenantModalOpen, setIsTenantModalOpen] = useState(false);
  const [isCreatingTenant, setIsCreatingTenant] = useState(false);
  const [tenantError, setTenantError] = useState<string | null>(null);
  const [tenantSuccess, setTenantSuccess] = useState<string | null>(null);
  // const { refreshBrand } = useBrand();

  const handleCreateTenant = async (tenantData: CreateTenantData) => {
    try {
      setIsCreatingTenant(true);
      setTenantError(null);
      setTenantSuccess(null);

      const response = await createTenant(tenantData);
      setTenantSuccess(`Tenant created successfully!`);

      return {
        success: true,
        tenantId: response?.id,
        tenantname: response?.name,
      };
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : "Failed to create tenant";
      setTenantError(errorMessage);
      console.error("Error creating tenant:", error);
      throw error;
    } finally {
      setIsCreatingTenant(false);
    }
  };

  const handleTenantCardClick = () => {
    if (!auth.user?.brandId) {
      setTenantError("You must be part of a brand to create a tenant.");
      return;
    }
    setTenantError(null);
    setIsTenantModalOpen(true);
  };

  return (
    <div className="block">
      {/* Success Message */}
      {tenantSuccess && (
        <div className="mb-4 p-3 bg-green-100 border border-green-400 text-green-700 rounded-lg">
          {tenantSuccess}
        </div>
      )}

      {/* Error Message */}
      {tenantError && (
        <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded-lg">
          {tenantError}
        </div>
      )}

      {/* Grid layout for both cards */}
      <div className="grid grid-cols-1 md:grid-cols-1 gap-6">
        {/* Create Report Card */}
        <div
          className="flex flex-col items-center justify-center rounded-3xl border border-gray-300 hover:border-r-blue-600 hover:border-b-blue-600   duration-300 ease-in-out p-6 w-full h-64 hover:shadow-lg transition cursor-pointer bg-white"
          onClick={handleTenantCardClick}
        >
          <BsFillPlusCircleFill className="w-8 h-8 text-black" />
          <p className="font-semibold text-sm mt-2">NEW REPORT</p>
        </div>
      </div>
      <div className="flex items-center justify-center mt-5 px-4">
        <p className="text-xs text-gray-400">
          Agent can take up to 15 minutes to generate a report
        </p>
      </div>

      {/* Report Upload Modal */}
      <ReportUploadModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />

      {/* Tenant Creation Modal */}
      {auth.user?.brandId && (
        <TenantModal
          isOpen={isTenantModalOpen}
          onClose={() => { 
            setIsTenantModalOpen(false);
            // refreshBrand();
          }}
          onSave={handleCreateTenant}
          brandId={auth.user.brandId}
          isLoading={isCreatingTenant}
        />
      )}
    </div>
  );
};

export default TenantUpload;
